import React, { useEffect, useState, useRef } from 'react';
 import FPS_Month_RO_Report from '../RoStatus/FPS_Month_RO_Report';
 import CircularProgress from '@mui/material/CircularProgress';
 import Box from '@mui/material/Box';

const SDM_Month_RO_Report_data = async (params) => {  
    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/Ro/sdm_month_ro_report`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const SDM_Month_RO_Report = ({ month, year, dist_code }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContenttt, setRenderContenttt] = useState(null);
    const details2 = useRef(null); // Use ref to scroll to this div

    const handleAfsoClick = (month, year, dist_code, afso_code) => {

        setTimeout(() => {
            setRenderContenttt(null);

            setRenderContenttt(
                <FPS_Month_RO_Report
                    month={month}
                    year={year}
                    dist_code={dist_code}
                    afso_code={afso_code}
                />
            );

        }, 10);
    };


    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await SDM_Month_RO_Report_data({ month, year, dist_code });

                setTabHeading(response_data.heading);
                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, dist_code]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && details2.current) {
            details2.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, error, reportData]);

    if (loading) {
        return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
            <CircularProgress />
        </Box></div>
    }
    if (error) {
        return <div class="mainhead" align="center">
        Internal Error
        </div>
      }
      if (reportData.length === 0) {
          return <div class="mainhead" align="center">
          No data found 
       </div>
        }
      
        const totals = reportData.reduce(
            (acc, item) => {
              acc.tot_fps+=item.tot_fps || 0;
              acc.tot_order += item.tot_order || 0;
              acc.tot_truck += item.tot_truck || 0;
              acc.pending += item.pending || 0;
              acc.received += item.received || 0;
     return acc;
   },
   {
         tot_fps:0,
         tot_order:0,
         tot_truck:0,
         pending:0,
         received:0,
    
   }
 );
    
    return (
        <>
            <table align="center" width="60%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={7}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                         <th rowSpan={2}>Sl No</th>
	                     <th rowSpan={2}>Office</th>
                         <th rowSpan={2}>Total<br/>FPS</th>
                    	 <th rowSpan={2}>Total<br/>Allocation<br/>Orders</th>
	                     <th colSpan={3}>Truck Chits</th>

                    </tr>
               
                    <tr className="tableheader">
                        <th>Total</th>
	                    <th>Received</th>
                    	<th>Pending for<br/>Receive</th>	
                    </tr>
                </thead>
              <tbody>
                    {
                             reportData.map((item, index) => (
                                <tr key={item.afso_code}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ textAlign: 'left' }}>
                                        <a
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={() => handleAfsoClick(month, year,  dist_code, item.afso_code)}
                                        >
                                            {item.afso_name_en}
                                        </a>
                                    </td>
                                    <td style={{ textAlign: 'right' }}>{item.tot_fps}</td>
                                    <td style={{ textAlign: 'right' }}>{item.tot_order}</td>
                                    <td style={{ textAlign: 'right' }}>{item.tot_truck}</td>
                                    <td style={{ textAlign: 'right' }}>{item.received}</td>
                                    <td style={{ textAlign: 'right' }}>{item.pending}</td>
                                </tr>
                            ))  }
                    <tr className="tableheader">
                                   <td colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
                                   <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_fps}</td>
                                   <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_order}</td>
                                   <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_truck}</td>
                                   <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.received}</td>
                                   <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.pending}</td>
                     </tr>
                </tbody>
            </table>
            <br /><br />
            <div id='detailsRR' ref={details2}>{renderContenttt}</div>
        </>
    );
};

export default SDM_Month_RO_Report;
